<template>
  <OCol fill-y stretch-y>
    <v-list dense>
      <template v-for="(item, i) in items">
        <v-divider v-if="item.isDivider" :key="`div${i}`" />

        <!-- itens avulsos -->
        <v-list-item
          v-else-if="item.subitems == null"
          :key="i"
          :to="item.path"
          exact
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title v-text="item.label" />
        </v-list-item>

        <!-- itens com subitems -->
        <v-list-group
          v-else
          :key="i"
          v-model="item.model"
          :prepend-icon="item.icon"
          :append-icon="
            item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
          "
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(sub, i) in item.subitems"
            :key="i"
            :to="sub.path"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ sub.label }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>

      <v-list-item @click="doLogout">
        <v-list-item-action>
          <v-icon>power_settings_new</v-icon>
        </v-list-item-action>
        <v-list-item-title>Logout</v-list-item-title>
      </v-list-item>
    </v-list>

<v-spacer />

  </OCol>
</template>

<script>
export default {
  computed: {
    items() {
      return [
        { label: 'Queues', path: '/mobile/queues', icon: 'mdi-signal flip-and-rotate' },
        { label: 'Base Instalada', path: '/installed-base', icon: 'mdi-developer-board' },
        { label: 'Organizações', path: '/orgs', icon: 'mdi-domain' },
        {
          label: 'Setup',
          icon: 'settings',
          subitems: [
            { label: 'SysConfigs', path: '/setup/sysconfigs' },

          ]
        },
        {
          label: 'Accounts',
          icon: 'mdi-account',
          subitems: [
            { label: 'Beeper', path: '/setup/sysconfigs' },
            { label: 'Accounts', path: '/setup/sysconfigs' },
            { label: 'Subscriptions', path: '/setup/sysconfigs' },

          ]
        },
        {
          label: 'Tools',
          icon: 'mdi-wrench',
          subitems: [
            { label: 'Histórico de Módulos', path: '/tools/history', icon: 'history' },
            { label: 'Histórico de Objetos', path: '/tools/paperman', icon: 'history' },
            { label: 'Histórico de Eventos', path: '/tools/rd-events-history', icon: 'history' },
            { label: 'Histórico de FW Updates', path: '/tools/fwupdates', icon: 'history' },
          ]
        }
      ]
    }
  },
  methods: {
    doLogout() {
      this.$emit('close-drawer')
      this.$store.dispatch('auth/doLogout')
    }
  }
}
</script>

<style lang="sass">
.flip-and-rotate
  transform: scaleY(-1) rotate(90deg)
</style>
